// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tc_cq","delete":"styles_delete__2rPKM","update":"styles_update__3R-rK","add":"styles_add__1PANc"};